export const checkPlusLabelNumber = (value?: number) => {
    if (value && value > 0) {
        return `+${value.toLocaleString()}`
    }
}
